export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11931.d0051701.jpg";